import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import BreadcrumbNav from '@/components/base/BreadcrumbNav';
import ComicCard from '@/components/feature/ComicCard';
import SEOSchema from '@/components/feature/SEOSchema';
import { categories, getComicsByCategory } from '@/mocks/comics';

const categoryMeta: Record<string, { title: string; description: string }> = {
  romance: {
    title: '恋爱漫画 - 韩国漫画在线 | 免费浪漫韩漫',
    description: '韩国漫画在线恋爱分类，汇集最甜美的韩国恋爱漫画。从校园纯爱到职场恋情，从甜宠日常到虐心虐恋，各种浪漫韩漫满足您的少女心。',
  },
  fantasy: {
    title: '奇幻漫画 - 韩国漫画在线 | 魔法冒险韩漫',
    description: '韩国漫画在线奇幻分类，收录最精彩的奇幻韩国漫画。穿越异世界、魔法学院、龙族冒险、超能力战斗，带您进入不可思议的韩漫世界。',
  },
  action: {
    title: '动作漫画 - 韩国漫画在线 | 热血格斗韩漫',
    description: '韩国漫画在线动作分类，汇集最热血的韩国动作漫画。拳拳到肉的格斗场面、扣人心弦的追逐战、精彩刺激的战斗剧情，让您感受韩漫的无限张力。',
  },
  thriller: {
    title: '悬疑漫画 - 韩国漫画在线 | 推理惊悚韩漫',
    description: '韩国漫画在线悬疑分类，搜罗最烧脑的韩国悬疑漫画。连环案件、心理博弈、密室逃脱、超自然现象，每一部都让您欲罢不能。',
  },
  'slice-of-life': {
    title: '日常漫画 - 韩国漫画在线 | 治愈温暖韩漫',
    description: '韩国漫画在线日常分类，呈现最温暖的韩国日常漫画。猫咪咖啡馆、独自生活、邻里故事，每一页都充满了生活中的小确幸。',
  },
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'romance');

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
    }
  }, [slug]);

  const comics = getComicsByCategory(activeSlug);
  const category = categories.find((c) => c.slug === activeSlug);
  const meta = categoryMeta[activeSlug] || categoryMeta.romance;

  return (
    <>
      <ScrollToTop />
      <SEOSchema
        pageType="WebPage"
        pageTitle={meta.title}
        pageDescription={meta.description}
        canonicalUrl={`https://koreancomics.cn/category/${activeSlug}`}
        breadcrumbItems={[
          { label: '首页', to: '/' },
          { label: category?.name || '分类' },
        ]}
      />
      <Navbar />
      <main className="pt-16">
        <div className="px-4 md:px-6 py-6 md:py-8">
          <BreadcrumbNav
            items={[
              { label: '首页', to: '/' },
              { label: category?.name || '分类' },
            ]}
          />

          <div className="mt-4 md:mt-6">
            <h1 className="text-2xl md:text-3xl font-heading text-foreground-900">
              {category?.name}漫画
            </h1>
            <p className="text-sm text-foreground-500 mt-2 max-w-2xl">
              {meta.description}
            </p>
          </div>

          <div className="mt-6 flex items-center gap-2 flex-wrap">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  activeSlug === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                <i className={`${cat.icon} mr-1.5 text-xs w-3 h-3 inline-flex items-center justify-center`}></i>
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="mt-6 md:mt-8">
            {comics.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4" data-product-shop="">
                {comics.map((comic) => (
                  <ComicCard key={comic.id} comic={comic} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类暂无漫画</p>
              </div>
            )}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}